import { render, staticRenderFns } from "./Infringement.vue?vue&type=template&id=db0ddcfc&scoped=true&"
import script from "./Infringement.vue?vue&type=script&lang=js&"
export * from "./Infringement.vue?vue&type=script&lang=js&"
import style0 from "./Infringement.vue?vue&type=style&index=0&id=db0ddcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0ddcfc",
  null
  
)

export default component.exports